
const rewrites = {
	"it": [],
	"en": [
		{
			"source": "/collections/brand/:slug_brand/:slug_collezione/:slug_tonalita",
			"destination": "/collezioni/brand/:slug_brand/:slug_collezione/:slug_tonalita"
		},
		{
			"source": "/collections/brand/:slug_brand/:slug_collezione",
			"destination": "/collezioni/brand/:slug_brand/:slug_collezione"
		},
		{
			"source": "/collections/brand/:slug_brand",
			"destination": "/collezioni/brand/:slug_brand"
		},
		{
			"source": "/sustainability/certifications",
			"destination": "/sostenibilita/certificazioni"
		},
		{
			"source": "/collections/location/:slug",
			"destination": "/collezioni/ambienti/:slug"
		},
		{
			"source": "/company/technologies/:slug",
			"destination": "/azienda/tecnologie/:slug"
		},
		{
			"source": "/collections/effects/:slug",
			"destination": "/collezioni/effetti/:slug"
		},
		{
			"source": "/collections/formats/:slug",
			"destination": "/collezioni/formati/:slug"
		},
		{
			"source": "/company/creative-workshop",
			"destination": "/azienda/officina-creativa"
		},
		{
			"source": "/collections/brands/:slug",
			"destination": "/collezioni/brands/:slug"
		},
		{
			"source": "/collections/colors/:slug",
			"destination": "/collezioni/colori/:slug"
		},
		{
			"source": "/company/technologies",
			"destination": "/azienda/tecnologie"
		},
		{
			"source": "/sustainability/:slug",
			"destination": "/sostenibilita/:slug"
		},
		{
			"source": "/company/about-us",
			"destination": "/azienda/chi-siamo"
		},
		{
			"source": "/solutions/:slug",
			"destination": "/soluzioni/:slug"
		},
		{
			"source": "/projects/:slug",
			"destination": "/progetti/:slug"
		},
		{
			"source": "/sustainability",
			"destination": "/sostenibilita"
		},
		{
			"source": "/collections",
			"destination": "/collezioni"
		},
		{
			"source": "/solutions",
			"destination": "/soluzioni"
		},
		{
			"source": "/projects",
			"destination": "/progetti"
		},
		{
			"source": "/contacts",
			"destination": "/contatti"
		},
		{
			"source": "/company",
			"destination": "/azienda"
		}
	],
	"de": [
		{
			"source": "/kollektionen/marke/:slug_brand/:slug_collezione/:slug_tonalita",
			"destination": "/collezioni/brand/:slug_brand/:slug_collezione/:slug_tonalita"
		},
		{
			"source": "/kollektionen/marke/:slug_brand/:slug_collezione",
			"destination": "/collezioni/brand/:slug_brand/:slug_collezione"
		},
		{
			"source": "/nachhaltigkeit/zertifizierungen",
			"destination": "/sostenibilita/certificazioni"
		},
		{
			"source": "/kollektionen/marke/:slug_brand",
			"destination": "/collezioni/brand/:slug_brand"
		},
		{
			"source": "/unternehmen/technologien/:slug",
			"destination": "/azienda/tecnologie/:slug"
		},
		{
			"source": "/unternehmen/kreativwerkstatt",
			"destination": "/azienda/officina-creativa"
		},
		{
			"source": "/kollektionen/effekte/:slug",
			"destination": "/collezioni/effetti/:slug"
		},
		{
			"source": "/kollektionen/bereich/:slug",
			"destination": "/collezioni/ambienti/:slug"
		},
		{
			"source": "/kollektionen/formate/:slug",
			"destination": "/collezioni/formati/:slug"
		},
		{
			"source": "/kollektionen/marken/:slug",
			"destination": "/collezioni/brands/:slug"
		},
		{
			"source": "/kollektionen/farben/:slug",
			"destination": "/collezioni/colori/:slug"
		},
		{
			"source": "/unternehmen/technologien",
			"destination": "/azienda/tecnologie"
		},
		{
			"source": "/unternehmen/uber-uns",
			"destination": "/azienda/chi-siamo"
		},
		{
			"source": "/nachhaltigkeit/:slug",
			"destination": "/sostenibilita/:slug"
		},
		{
			"source": "/projekte/:slug",
			"destination": "/progetti/:slug"
		},
		{
			"source": "/losungen/:slug",
			"destination": "/soluzioni/:slug"
		},
		{
			"source": "/nachhaltigkeit",
			"destination": "/sostenibilita"
		},
		{
			"source": "/kollektionen",
			"destination": "/collezioni"
		},
		{
			"source": "/unternehmen",
			"destination": "/azienda"
		},
		{
			"source": "/projekte",
			"destination": "/progetti"
		},
		{
			"source": "/losungen",
			"destination": "/soluzioni"
		},
		{
			"source": "/kontakt",
			"destination": "/contatti"
		}
	],
	"fra": [
		{
			"source": "/collections/marque/:slug_brand/:slug_collezione/:slug_tonalita",
			"destination": "/collezioni/brand/:slug_brand/:slug_collezione/:slug_tonalita"
		},
		{
			"source": "/collections/marque/:slug_brand/:slug_collezione",
			"destination": "/collezioni/brand/:slug_brand/:slug_collezione"
		},
		{
			"source": "/collections/marque/:slug_brand",
			"destination": "/collezioni/brand/:slug_brand"
		},
		{
			"source": "/collections/application/:slug",
			"destination": "/collezioni/ambienti/:slug"
		},
		{
			"source": "/entreprise/technologies/:slug",
			"destination": "/azienda/tecnologie/:slug"
		},
		{
			"source": "/collections/couleurs/:slug",
			"destination": "/collezioni/colori/:slug"
		},
		{
			"source": "/entreprise/qui-nous-sommes",
			"destination": "/azienda/chi-siamo"
		},
		{
			"source": "/entreprise/atelier-creatif",
			"destination": "/azienda/officina-creativa"
		},
		{
			"source": "/soutenabilite/attestations",
			"destination": "/sostenibilita/certificazioni"
		},
		{
			"source": "/collections/marques/:slug",
			"destination": "/collezioni/brands/:slug"
		},
		{
			"source": "/collections/formats/:slug",
			"destination": "/collezioni/formati/:slug"
		},
		{
			"source": "/collections/effets/:slug",
			"destination": "/collezioni/effetti/:slug"
		},
		{
			"source": "/entreprise/technologies",
			"destination": "/azienda/tecnologie"
		},
		{
			"source": "/soutenabilite/:slug",
			"destination": "/sostenibilita/:slug"
		},
		{
			"source": "/solutions/:slug",
			"destination": "/soluzioni/:slug"
		},
		{
			"source": "/projets/:slug",
			"destination": "/progetti/:slug"
		},
		{
			"source": "/soutenabilite",
			"destination": "/sostenibilita"
		},
		{
			"source": "/collections",
			"destination": "/collezioni"
		},
		{
			"source": "/entreprise",
			"destination": "/azienda"
		},
		{
			"source": "/solutions",
			"destination": "/soluzioni"
		},
		{
			"source": "/contacts",
			"destination": "/contatti"
		},
		{
			"source": "/projets",
			"destination": "/progetti"
		}
	],
	"esp": [
		{
			"source": "/colecciones/marca/:slug_brand/:slug_collezione/:slug_tonalita",
			"destination": "/collezioni/brand/:slug_brand/:slug_collezione/:slug_tonalita"
		},
		{
			"source": "/colecciones/marca/:slug_brand/:slug_collezione",
			"destination": "/collezioni/brand/:slug_brand/:slug_collezione"
		},
		{
			"source": "/colecciones/medio-ambiente/:slug",
			"destination": "/collezioni/ambienti/:slug"
		},
		{
			"source": "/sostenibilidad/certificaciones",
			"destination": "/sostenibilita/certificazioni"
		},
		{
			"source": "/colecciones/marca/:slug_brand",
			"destination": "/collezioni/brand/:slug_brand"
		},
		{
			"source": "/colecciones/formatos/:slug",
			"destination": "/collezioni/formati/:slug"
		},
		{
			"source": "/colecciones/efectos/:slug",
			"destination": "/collezioni/effetti/:slug"
		},
		{
			"source": "/colecciones/colores/:slug",
			"destination": "/collezioni/colori/:slug"
		},
		{
			"source": "/empresa/tecnologias/:slug",
			"destination": "/azienda/tecnologie/:slug"
		},
		{
			"source": "/colecciones/marcas/:slug",
			"destination": "/collezioni/brands/:slug"
		},
		{
			"source": "/empresa/taller-creativo",
			"destination": "/azienda/officina-creativa"
		},
		{
			"source": "/empresa/quienes-somos",
			"destination": "/azienda/chi-siamo"
		},
		{
			"source": "/sostenibilidad/:slug",
			"destination": "/sostenibilita/:slug"
		},
		{
			"source": "/empresa/tecnologias",
			"destination": "/azienda/tecnologie"
		},
		{
			"source": "/soluciones/:slug",
			"destination": "/soluzioni/:slug"
		},
		{
			"source": "/proyectos/:slug",
			"destination": "/progetti/:slug"
		},
		{
			"source": "/sostenibilidad",
			"destination": "/sostenibilita"
		},
		{
			"source": "/colecciones",
			"destination": "/collezioni"
		},
		{
			"source": "/soluciones",
			"destination": "/soluzioni"
		},
		{
			"source": "/proyectos",
			"destination": "/progetti"
		},
		{
			"source": "/contactos",
			"destination": "/contatti"
		},
		{
			"source": "/empresa",
			"destination": "/azienda"
		}
	],
	"us": [
		{
			"source": "/collections/brand/:slug_brand/:slug_collezione/:slug_tonalita",
			"destination": "/collezioni/brand/:slug_brand/:slug_collezione/:slug_tonalita"
		},
		{
			"source": "/collections/brand/:slug_brand/:slug_collezione",
			"destination": "/collezioni/brand/:slug_brand/:slug_collezione"
		},
		{
			"source": "/collections/brand/:slug_brand",
			"destination": "/collezioni/brand/:slug_brand"
		},
		{
			"source": "/sustainability/certifications",
			"destination": "/sostenibilita/certificazioni"
		},
		{
			"source": "/collections/location/:slug",
			"destination": "/collezioni/ambienti/:slug"
		},
		{
			"source": "/company/technologies/:slug",
			"destination": "/azienda/tecnologie/:slug"
		},
		{
			"source": "/collections/effects/:slug",
			"destination": "/collezioni/effetti/:slug"
		},
		{
			"source": "/collections/formats/:slug",
			"destination": "/collezioni/formati/:slug"
		},
		{
			"source": "/company/creative-workshop",
			"destination": "/azienda/officina-creativa"
		},
		{
			"source": "/collections/brands/:slug",
			"destination": "/collezioni/brands/:slug"
		},
		{
			"source": "/collections/colors/:slug",
			"destination": "/collezioni/colori/:slug"
		},
		{
			"source": "/company/technologies",
			"destination": "/azienda/tecnologie"
		},
		{
			"source": "/sustainability/:slug",
			"destination": "/sostenibilita/:slug"
		},
		{
			"source": "/company/about-us",
			"destination": "/azienda/chi-siamo"
		},
		{
			"source": "/solutions/:slug",
			"destination": "/soluzioni/:slug"
		},
		{
			"source": "/projects/:slug",
			"destination": "/progetti/:slug"
		},
		{
			"source": "/sustainability",
			"destination": "/sostenibilita"
		},
		{
			"source": "/collections",
			"destination": "/collezioni"
		},
		{
			"source": "/solutions",
			"destination": "/soluzioni"
		},
		{
			"source": "/projects",
			"destination": "/progetti"
		},
		{
			"source": "/contacts",
			"destination": "/contatti"
		},
		{
			"source": "/company",
			"destination": "/azienda"
		}
	],
	"es": [
		{
			"source": "/colecciones/marca/:slug_brand/:slug_collezione/:slug_tonalita",
			"destination": "/collezioni/brand/:slug_brand/:slug_collezione/:slug_tonalita"
		},
		{
			"source": "/colecciones/marca/:slug_brand/:slug_collezione",
			"destination": "/collezioni/brand/:slug_brand/:slug_collezione"
		},
		{
			"source": "/colecciones/medio-ambiente/:slug",
			"destination": "/collezioni/ambienti/:slug"
		},
		{
			"source": "/sostenibilidad/certificaciones",
			"destination": "/sostenibilita/certificazioni"
		},
		{
			"source": "/colecciones/marca/:slug_brand",
			"destination": "/collezioni/brand/:slug_brand"
		},
		{
			"source": "/colecciones/formatos/:slug",
			"destination": "/collezioni/formati/:slug"
		},
		{
			"source": "/colecciones/efectos/:slug",
			"destination": "/collezioni/effetti/:slug"
		},
		{
			"source": "/colecciones/colores/:slug",
			"destination": "/collezioni/colori/:slug"
		},
		{
			"source": "/empresa/tecnologias/:slug",
			"destination": "/azienda/tecnologie/:slug"
		},
		{
			"source": "/colecciones/marcas/:slug",
			"destination": "/collezioni/brands/:slug"
		},
		{
			"source": "/empresa/taller-creativo",
			"destination": "/azienda/officina-creativa"
		},
		{
			"source": "/empresa/quienes-somos",
			"destination": "/azienda/chi-siamo"
		},
		{
			"source": "/sostenibilidad/:slug",
			"destination": "/sostenibilita/:slug"
		},
		{
			"source": "/empresa/tecnologias",
			"destination": "/azienda/tecnologie"
		},
		{
			"source": "/soluciones/:slug",
			"destination": "/soluzioni/:slug"
		},
		{
			"source": "/proyectos/:slug",
			"destination": "/progetti/:slug"
		},
		{
			"source": "/sostenibilidad",
			"destination": "/sostenibilita"
		},
		{
			"source": "/colecciones",
			"destination": "/collezioni"
		},
		{
			"source": "/soluciones",
			"destination": "/soluzioni"
		},
		{
			"source": "/proyectos",
			"destination": "/progetti"
		},
		{
			"source": "/contactos",
			"destination": "/contatti"
		},
		{
			"source": "/empresa",
			"destination": "/azienda"
		}
	],
	"fr": [
		{
			"source": "/collections/marque/:slug_brand/:slug_collezione/:slug_tonalita",
			"destination": "/collezioni/brand/:slug_brand/:slug_collezione/:slug_tonalita"
		},
		{
			"source": "/collections/marque/:slug_brand/:slug_collezione",
			"destination": "/collezioni/brand/:slug_brand/:slug_collezione"
		},
		{
			"source": "/collections/marque/:slug_brand",
			"destination": "/collezioni/brand/:slug_brand"
		},
		{
			"source": "/collections/application/:slug",
			"destination": "/collezioni/ambienti/:slug"
		},
		{
			"source": "/entreprise/technologies/:slug",
			"destination": "/azienda/tecnologie/:slug"
		},
		{
			"source": "/collections/couleurs/:slug",
			"destination": "/collezioni/colori/:slug"
		},
		{
			"source": "/entreprise/qui-nous-sommes",
			"destination": "/azienda/chi-siamo"
		},
		{
			"source": "/entreprise/atelier-creatif",
			"destination": "/azienda/officina-creativa"
		},
		{
			"source": "/soutenabilite/attestations",
			"destination": "/sostenibilita/certificazioni"
		},
		{
			"source": "/collections/marques/:slug",
			"destination": "/collezioni/brands/:slug"
		},
		{
			"source": "/collections/formats/:slug",
			"destination": "/collezioni/formati/:slug"
		},
		{
			"source": "/collections/effets/:slug",
			"destination": "/collezioni/effetti/:slug"
		},
		{
			"source": "/entreprise/technologies",
			"destination": "/azienda/tecnologie"
		},
		{
			"source": "/soutenabilite/:slug",
			"destination": "/sostenibilita/:slug"
		},
		{
			"source": "/solutions/:slug",
			"destination": "/soluzioni/:slug"
		},
		{
			"source": "/projets/:slug",
			"destination": "/progetti/:slug"
		},
		{
			"source": "/soutenabilite",
			"destination": "/sostenibilita"
		},
		{
			"source": "/collections",
			"destination": "/collezioni"
		},
		{
			"source": "/entreprise",
			"destination": "/azienda"
		},
		{
			"source": "/solutions",
			"destination": "/soluzioni"
		},
		{
			"source": "/contacts",
			"destination": "/contatti"
		},
		{
			"source": "/projets",
			"destination": "/progetti"
		}
	]
}

const redirects = {
	"it": [],
	"en": [],
	"de": [],
	"fra": [],
	"esp": [],
	"us": [],
	"es": [],
	"fr": []
}

const pathTranslations = {
	"it": {
		"/": "/",
		"/collezioni": "/collezioni",
		"/collezioni/brand": "/collezioni/brand",
		"/collezioni/brand/[slug]": "/collezioni/brand/[slug]",
		"/collezioni/brand/[slug]/[slug]": "/collezioni/brand/[slug]/[slug]",
		"/collezioni/brand/[slug]/[slug]/[slug]": "/collezioni/brand/[slug]/[slug]/[slug]",
		"/collezioni/brands": "/collezioni/brands",
		"/collezioni/brands/[slug]": "/collezioni/brands/[slug]",
		"/collezioni/effetti": "/collezioni/effetti",
		"/collezioni/effetti/[slug]": "/collezioni/effetti/[slug]",
		"/collezioni/colori": "/collezioni/colori",
		"/collezioni/colori/[slug]": "/collezioni/colori/[slug]",
		"/collezioni/ambienti": "/collezioni/ambienti",
		"/collezioni/ambienti/[slug]": "/collezioni/ambienti/[slug]",
		"/collezioni/formati": "/collezioni/formati",
		"/collezioni/formati/[slug]": "/collezioni/formati/[slug]",
		"/progetti": "/progetti",
		"/progetti/[slug]": "/progetti/[slug]",
		"/soluzioni": "/soluzioni",
		"/soluzioni/[slug]": "/soluzioni/[slug]",
		"/magazine": "/magazine",
		"/magazine/[slug]": "/magazine/[slug]",
		"/azienda": "/azienda",
		"/azienda/chi-siamo": "/azienda/chi-siamo",
		"/azienda/officina-creativa": "/azienda/officina-creativa",
		"/azienda/tecnologie": "/azienda/tecnologie",
		"/azienda/tecnologie/[slug]": "/azienda/tecnologie/[slug]",
		"/sostenibilita": "/sostenibilita",
		"/sostenibilita/certificazioni": "/sostenibilita/certificazioni",
		"/sostenibilita/[slug]": "/sostenibilita/[slug]",
		"/newsletter": "/newsletter",
		"/contatti": "/contatti",
		"/rivenditori": "/rivenditori",
		"/rivenditori/contatta/[slug]": "/rivenditori/contatta/[slug]",
		"/rivenditori/[slug]": "/rivenditori/[slug]",
		"/rivenditori/[slug]/[slug]": "/rivenditori/[slug]/[slug]",
		"/rivenditori/[slug]/[slug]/[slug]": "/rivenditori/[slug]/[slug]/[slug]",
		"/downloadarea": "/downloadarea",
		"/search": "/search",
		"/taxes": "/taxes"
	},
	"en": {
		"/": "/",
		"/collezioni": "/collections",
		"/collezioni/brand": "/collections/brand",
		"/collezioni/brand/[slug]": "/collections/brand/[slug]",
		"/collezioni/brand/[slug]/[slug]": "/collections/brand/[slug]/[slug]",
		"/collezioni/brand/[slug]/[slug]/[slug]": "/collections/brand/[slug]/[slug]/[slug]",
		"/collezioni/brands": "/collections/brands",
		"/collezioni/brands/[slug]": "/collections/brands/[slug]",
		"/collezioni/effetti": "/collections/effects",
		"/collezioni/effetti/[slug]": "/collections/effects/[slug]",
		"/collezioni/colori": "/collections/colors",
		"/collezioni/colori/[slug]": "/collections/colors/[slug]",
		"/collezioni/ambienti": "/collections/location",
		"/collezioni/ambienti/[slug]": "/collections/location/[slug]",
		"/collezioni/formati": "/collections/formats",
		"/collezioni/formati/[slug]": "/collections/formats/[slug]",
		"/progetti": "/projects",
		"/progetti/[slug]": "/projects/[slug]",
		"/soluzioni": "/solutions",
		"/soluzioni/[slug]": "/solutions/[slug]",
		"/magazine": "/magazine",
		"/magazine/[slug]": "/magazine/[slug]",
		"/azienda": "/company",
		"/azienda/chi-siamo": "/company/about-us",
		"/azienda/officina-creativa": "/company/creative-workshop",
		"/azienda/tecnologie": "/company/technologies",
		"/azienda/tecnologie/[slug]": "/company/technologies/[slug]",
		"/sostenibilita": "/sustainability",
		"/sostenibilita/certificazioni": "/sustainability/certifications",
		"/sostenibilita/[slug]": "/sustainability/[slug]",
		"/newsletter": "/newsletter",
		"/contatti": "/contacts",
		"/rivenditori": "/rivenditori",
		"/rivenditori/contatta/[slug]": "/rivenditori/contatta/[slug]",
		"/rivenditori/[slug]": "/rivenditori/[slug]",
		"/rivenditori/[slug]/[slug]": "/rivenditori/[slug]/[slug]",
		"/rivenditori/[slug]/[slug]/[slug]": "/rivenditori/[slug]/[slug]/[slug]",
		"/downloadarea": "/downloadarea",
		"/search": "/search",
		"/taxes": "/taxes"
	},
	"de": {
		"/": "/",
		"/collezioni": "/kollektionen",
		"/collezioni/brand": "/kollektionen/marke",
		"/collezioni/brand/[slug]": "/kollektionen/marke/[slug]",
		"/collezioni/brand/[slug]/[slug]": "/kollektionen/marke/[slug]/[slug]",
		"/collezioni/brand/[slug]/[slug]/[slug]": "/kollektionen/marke/[slug]/[slug]/[slug]",
		"/collezioni/brands": "/kollektionen/marken",
		"/collezioni/brands/[slug]": "/kollektionen/marken/[slug]",
		"/collezioni/effetti": "/kollektionen/effekte",
		"/collezioni/effetti/[slug]": "/kollektionen/effekte/[slug]",
		"/collezioni/colori": "/kollektionen/farben",
		"/collezioni/colori/[slug]": "/kollektionen/farben/[slug]",
		"/collezioni/ambienti": "/kollektionen/bereich",
		"/collezioni/ambienti/[slug]": "/kollektionen/bereich/[slug]",
		"/collezioni/formati": "/kollektionen/formate",
		"/collezioni/formati/[slug]": "/kollektionen/formate/[slug]",
		"/progetti": "/projekte",
		"/progetti/[slug]": "/projekte/[slug]",
		"/soluzioni": "/losungen",
		"/soluzioni/[slug]": "/losungen/[slug]",
		"/magazine": "/magazine",
		"/magazine/[slug]": "/magazine/[slug]",
		"/azienda": "/unternehmen",
		"/azienda/chi-siamo": "/unternehmen/uber-uns",
		"/azienda/officina-creativa": "/unternehmen/kreativwerkstatt",
		"/azienda/tecnologie": "/unternehmen/technologien",
		"/azienda/tecnologie/[slug]": "/unternehmen/technologien/[slug]",
		"/sostenibilita": "/nachhaltigkeit",
		"/sostenibilita/certificazioni": "/nachhaltigkeit/zertifizierungen",
		"/sostenibilita/[slug]": "/nachhaltigkeit/[slug]",
		"/newsletter": "/newsletter",
		"/contatti": "/kontakt",
		"/rivenditori": "/rivenditori",
		"/rivenditori/contatta/[slug]": "/rivenditori/contatta/[slug]",
		"/rivenditori/[slug]": "/rivenditori/[slug]",
		"/rivenditori/[slug]/[slug]": "/rivenditori/[slug]/[slug]",
		"/rivenditori/[slug]/[slug]/[slug]": "/rivenditori/[slug]/[slug]/[slug]",
		"/downloadarea": "/downloadarea",
		"/search": "/search",
		"/taxes": "/taxes"
	},
	"fra": {
		"/": "/",
		"/collezioni": "/collections",
		"/collezioni/brand": "/collections/marque",
		"/collezioni/brand/[slug]": "/collections/marque/[slug]",
		"/collezioni/brand/[slug]/[slug]": "/collections/marque/[slug]/[slug]",
		"/collezioni/brand/[slug]/[slug]/[slug]": "/collections/marque/[slug]/[slug]/[slug]",
		"/collezioni/brands": "/collections/marques",
		"/collezioni/brands/[slug]": "/collections/marques/[slug]",
		"/collezioni/effetti": "/collections/effets",
		"/collezioni/effetti/[slug]": "/collections/effets/[slug]",
		"/collezioni/colori": "/collections/couleurs",
		"/collezioni/colori/[slug]": "/collections/couleurs/[slug]",
		"/collezioni/ambienti": "/collections/application",
		"/collezioni/ambienti/[slug]": "/collections/application/[slug]",
		"/collezioni/formati": "/collections/formats",
		"/collezioni/formati/[slug]": "/collections/formats/[slug]",
		"/progetti": "/projets",
		"/progetti/[slug]": "/projets/[slug]",
		"/soluzioni": "/solutions",
		"/soluzioni/[slug]": "/solutions/[slug]",
		"/magazine": "/magazine",
		"/magazine/[slug]": "/magazine/[slug]",
		"/azienda": "/entreprise",
		"/azienda/chi-siamo": "/entreprise/qui-nous-sommes",
		"/azienda/officina-creativa": "/entreprise/atelier-creatif",
		"/azienda/tecnologie": "/entreprise/technologies",
		"/azienda/tecnologie/[slug]": "/entreprise/technologies/[slug]",
		"/sostenibilita": "/soutenabilite",
		"/sostenibilita/certificazioni": "/soutenabilite/attestations",
		"/sostenibilita/[slug]": "/soutenabilite/[slug]",
		"/newsletter": "/newsletter",
		"/contatti": "/contacts",
		"/rivenditori": "/rivenditori",
		"/rivenditori/contatta/[slug]": "/rivenditori/contatta/[slug]",
		"/rivenditori/[slug]": "/rivenditori/[slug]",
		"/rivenditori/[slug]/[slug]": "/rivenditori/[slug]/[slug]",
		"/rivenditori/[slug]/[slug]/[slug]": "/rivenditori/[slug]/[slug]/[slug]",
		"/downloadarea": "/downloadarea",
		"/search": "/search",
		"/taxes": "/taxes"
	},
	"esp": {
		"/": "/",
		"/collezioni": "/colecciones",
		"/collezioni/brand": "/colecciones/marca",
		"/collezioni/brand/[slug]": "/colecciones/marca/[slug]",
		"/collezioni/brand/[slug]/[slug]": "/colecciones/marca/[slug]/[slug]",
		"/collezioni/brand/[slug]/[slug]/[slug]": "/colecciones/marca/[slug]/[slug]/[slug]",
		"/collezioni/brands": "/colecciones/marcas",
		"/collezioni/brands/[slug]": "/colecciones/marcas/[slug]",
		"/collezioni/effetti": "/colecciones/efectos",
		"/collezioni/effetti/[slug]": "/colecciones/efectos/[slug]",
		"/collezioni/colori": "/colecciones/colores",
		"/collezioni/colori/[slug]": "/colecciones/colores/[slug]",
		"/collezioni/ambienti": "/colecciones/medio-ambiente",
		"/collezioni/ambienti/[slug]": "/colecciones/medio-ambiente/[slug]",
		"/collezioni/formati": "/colecciones/formatos",
		"/collezioni/formati/[slug]": "/colecciones/formatos/[slug]",
		"/progetti": "/proyectos",
		"/progetti/[slug]": "/proyectos/[slug]",
		"/soluzioni": "/soluciones",
		"/soluzioni/[slug]": "/soluciones/[slug]",
		"/magazine": "/magazine",
		"/magazine/[slug]": "/magazine/[slug]",
		"/azienda": "/empresa",
		"/azienda/chi-siamo": "/empresa/quienes-somos",
		"/azienda/officina-creativa": "/empresa/taller-creativo",
		"/azienda/tecnologie": "/empresa/tecnologias",
		"/azienda/tecnologie/[slug]": "/empresa/tecnologias/[slug]",
		"/sostenibilita": "/sostenibilidad",
		"/sostenibilita/certificazioni": "/sostenibilidad/certificaciones",
		"/sostenibilita/[slug]": "/sostenibilidad/[slug]",
		"/newsletter": "/newsletter",
		"/contatti": "/contactos",
		"/rivenditori": "/rivenditori",
		"/rivenditori/contatta/[slug]": "/rivenditori/contatta/[slug]",
		"/rivenditori/[slug]": "/rivenditori/[slug]",
		"/rivenditori/[slug]/[slug]": "/rivenditori/[slug]/[slug]",
		"/rivenditori/[slug]/[slug]/[slug]": "/rivenditori/[slug]/[slug]/[slug]",
		"/downloadarea": "/downloadarea",
		"/search": "/search",
		"/taxes": "/taxes"
	},
	"us": {
		"/": "/",
		"/collezioni": "/collections",
		"/collezioni/brand": "/collections/brand",
		"/collezioni/brand/[slug]": "/collections/brand/[slug]",
		"/collezioni/brand/[slug]/[slug]": "/collections/brand/[slug]/[slug]",
		"/collezioni/brand/[slug]/[slug]/[slug]": "/collections/brand/[slug]/[slug]/[slug]",
		"/collezioni/brands": "/collections/brands",
		"/collezioni/brands/[slug]": "/collections/brands/[slug]",
		"/collezioni/effetti": "/collections/effects",
		"/collezioni/effetti/[slug]": "/collections/effects/[slug]",
		"/collezioni/colori": "/collections/colors",
		"/collezioni/colori/[slug]": "/collections/colors/[slug]",
		"/collezioni/ambienti": "/collections/location",
		"/collezioni/ambienti/[slug]": "/collections/location/[slug]",
		"/collezioni/formati": "/collections/formats",
		"/collezioni/formati/[slug]": "/collections/formats/[slug]",
		"/progetti": "/projects",
		"/progetti/[slug]": "/projects/[slug]",
		"/soluzioni": "/solutions",
		"/soluzioni/[slug]": "/solutions/[slug]",
		"/magazine": "/magazine",
		"/magazine/[slug]": "/magazine/[slug]",
		"/azienda": "/company",
		"/azienda/chi-siamo": "/company/about-us",
		"/azienda/officina-creativa": "/company/creative-workshop",
		"/azienda/tecnologie": "/company/technologies",
		"/azienda/tecnologie/[slug]": "/company/technologies/[slug]",
		"/sostenibilita": "/sustainability",
		"/sostenibilita/certificazioni": "/sustainability/certifications",
		"/sostenibilita/[slug]": "/sustainability/[slug]",
		"/newsletter": "/newsletter",
		"/contatti": "/contacts",
		"/rivenditori": "/rivenditori",
		"/rivenditori/contatta/[slug]": "/rivenditori/contatta/[slug]",
		"/rivenditori/[slug]": "/rivenditori/[slug]",
		"/rivenditori/[slug]/[slug]": "/rivenditori/[slug]/[slug]",
		"/rivenditori/[slug]/[slug]/[slug]": "/rivenditori/[slug]/[slug]/[slug]",
		"/downloadarea": "/downloadarea",
		"/search": "/search",
		"/taxes": "/taxes"
	},
	"es": {
		"/": "/",
		"/collezioni": "/colecciones",
		"/collezioni/brand": "/colecciones/marca",
		"/collezioni/brand/[slug]": "/colecciones/marca/[slug]",
		"/collezioni/brand/[slug]/[slug]": "/colecciones/marca/[slug]/[slug]",
		"/collezioni/brand/[slug]/[slug]/[slug]": "/colecciones/marca/[slug]/[slug]/[slug]",
		"/collezioni/brands": "/colecciones/marcas",
		"/collezioni/brands/[slug]": "/colecciones/marcas/[slug]",
		"/collezioni/effetti": "/colecciones/efectos",
		"/collezioni/effetti/[slug]": "/colecciones/efectos/[slug]",
		"/collezioni/colori": "/colecciones/colores",
		"/collezioni/colori/[slug]": "/colecciones/colores/[slug]",
		"/collezioni/ambienti": "/colecciones/medio-ambiente",
		"/collezioni/ambienti/[slug]": "/colecciones/medio-ambiente/[slug]",
		"/collezioni/formati": "/colecciones/formatos",
		"/collezioni/formati/[slug]": "/colecciones/formatos/[slug]",
		"/progetti": "/proyectos",
		"/progetti/[slug]": "/proyectos/[slug]",
		"/soluzioni": "/soluciones",
		"/soluzioni/[slug]": "/soluciones/[slug]",
		"/magazine": "/magazine",
		"/magazine/[slug]": "/magazine/[slug]",
		"/azienda": "/empresa",
		"/azienda/chi-siamo": "/empresa/quienes-somos",
		"/azienda/officina-creativa": "/empresa/taller-creativo",
		"/azienda/tecnologie": "/empresa/tecnologias",
		"/azienda/tecnologie/[slug]": "/empresa/tecnologias/[slug]",
		"/sostenibilita": "/sostenibilidad",
		"/sostenibilita/certificazioni": "/sostenibilidad/certificaciones",
		"/sostenibilita/[slug]": "/sostenibilidad/[slug]",
		"/newsletter": "/newsletter",
		"/contatti": "/contactos",
		"/rivenditori": "/rivenditori",
		"/rivenditori/contatta/[slug]": "/rivenditori/contatta/[slug]",
		"/rivenditori/[slug]": "/rivenditori/[slug]",
		"/rivenditori/[slug]/[slug]": "/rivenditori/[slug]/[slug]",
		"/rivenditori/[slug]/[slug]/[slug]": "/rivenditori/[slug]/[slug]/[slug]",
		"/downloadarea": "/downloadarea",
		"/search": "/search",
		"/taxes": "/taxes"
	},
	"fr": {
		"/": "/",
		"/collezioni": "/collections",
		"/collezioni/brand": "/collections/marque",
		"/collezioni/brand/[slug]": "/collections/marque/[slug]",
		"/collezioni/brand/[slug]/[slug]": "/collections/marque/[slug]/[slug]",
		"/collezioni/brand/[slug]/[slug]/[slug]": "/collections/marque/[slug]/[slug]/[slug]",
		"/collezioni/brands": "/collections/marques",
		"/collezioni/brands/[slug]": "/collections/marques/[slug]",
		"/collezioni/effetti": "/collections/effets",
		"/collezioni/effetti/[slug]": "/collections/effets/[slug]",
		"/collezioni/colori": "/collections/couleurs",
		"/collezioni/colori/[slug]": "/collections/couleurs/[slug]",
		"/collezioni/ambienti": "/collections/application",
		"/collezioni/ambienti/[slug]": "/collections/application/[slug]",
		"/collezioni/formati": "/collections/formats",
		"/collezioni/formati/[slug]": "/collections/formats/[slug]",
		"/progetti": "/projets",
		"/progetti/[slug]": "/projets/[slug]",
		"/soluzioni": "/solutions",
		"/soluzioni/[slug]": "/solutions/[slug]",
		"/magazine": "/magazine",
		"/magazine/[slug]": "/magazine/[slug]",
		"/azienda": "/entreprise",
		"/azienda/chi-siamo": "/entreprise/qui-nous-sommes",
		"/azienda/officina-creativa": "/entreprise/atelier-creatif",
		"/azienda/tecnologie": "/entreprise/technologies",
		"/azienda/tecnologie/[slug]": "/entreprise/technologies/[slug]",
		"/sostenibilita": "/soutenabilite",
		"/sostenibilita/certificazioni": "/soutenabilite/attestations",
		"/sostenibilita/[slug]": "/soutenabilite/[slug]",
		"/newsletter": "/newsletter",
		"/contatti": "/contacts",
		"/rivenditori": "/rivenditori",
		"/rivenditori/contatta/[slug]": "/rivenditori/contatta/[slug]",
		"/rivenditori/[slug]": "/rivenditori/[slug]",
		"/rivenditori/[slug]/[slug]": "/rivenditori/[slug]/[slug]",
		"/rivenditori/[slug]/[slug]/[slug]": "/rivenditori/[slug]/[slug]/[slug]",
		"/downloadarea": "/downloadarea",
		"/search": "/search",
		"/taxes": "/taxes"
	}
}

module.exports = { rewrites, redirects, pathTranslations }
